import { animate, Component, OnInit, state, style, transition, trigger, ViewEncapsulation } from '@angular/core';
import { RegisterOfBenefactorsEventType } from './register-of-benefactors.event.type';
import { AppEventDispatcher } from '../../utils/AppEventDispatcher';
import { TweenMax } from 'gsap';

@Component({
	selector: 'app-register-of-benefactors',
	templateUrl: './register-of-benefactors.component.html',
	styleUrls: ['./register-of-benefactors.component.styl'],
	encapsulation: ViewEncapsulation.None,
	animations: [
		trigger('detailExpand', [
			state('collapsed', style({height: '0px', minHeight: '0', display: 'none'})),
			state('expanded', style({height: '*'})),
			transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
		]),
	],
})

export class RegisterOfBenefactorsComponent implements OnInit {

	public title = 'Favorecidos';

	constructor() {}

	ngOnInit() {
		this.show();
	}

	show() {
		TweenMax.delayedCall(.3, () => {
			AppEventDispatcher.dispatch(RegisterOfBenefactorsEventType.STEPS.BENEFACTOR_LIST, { show: true });
		});
	}

	onSetTitle(data) {
		this.title = data.title;
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/register-of-benefactors/register-of-benefactors.component.ts